import React from "react";
import { BookOpen } from "lucide-react";
import { Field, Textarea, Input, ChipGroup, Toggle, SectionTitle } from "../primitives";
import { PERSONALITY_TAGS, INTEREST_TAGS, HOBBY_TAGS, ACTIVITY_TAGS } from "../constants";

export default function Step4About({ form, set }) {
  return (
    <div className="space-y-6">
      <SectionTitle icon={BookOpen} title="About me"
        subtitle="Tell your story — clients spend the most time on this section." />

      <Field label="Biography" required hint="Minimum 40 characters. Be authentic and inviting.">
        <Textarea
          value={form.bio}
          onChange={(e) => set({ bio: e.target.value })}
          className="min-h-[160px]"
          placeholder="Share who you are, what makes you special, and what an evening with you looks like…"
          data-testid="about-bio"
        />
        <div className="text-[10px] text-stone-500 text-right mt-1">{(form.bio || "").length} characters</div>
      </Field>

      <Field label="Personality" hint="Pick traits that describe you.">
        <ChipGroup
          options={PERSONALITY_TAGS}
          value={form.personality}
          onChange={(personality) => set({ personality })}
          testidPrefix="about-personality"
        />
      </Field>

      <Field label="Interests">
        <ChipGroup
          options={INTEREST_TAGS}
          value={form.interests}
          onChange={(interests) => set({ interests })}
          testidPrefix="about-interest"
        />
      </Field>

      <Field label="Hobbies">
        <ChipGroup
          options={HOBBY_TAGS}
          value={form.hobbies}
          onChange={(hobbies) => set({ hobbies })}
          testidPrefix="about-hobby"
        />
      </Field>

      <Field label="Favourite activities for dates">
        <ChipGroup
          options={ACTIVITY_TAGS}
          value={form.favourite_activities}
          onChange={(favourite_activities) => set({ favourite_activities })}
          testidPrefix="about-activity"
        />
      </Field>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Field label="Education">
          <Input
            value={form.education}
            onChange={(e) => set({ education: e.target.value })}
            placeholder="e.g. Architecture, Politecnico di Milano"
            data-testid="about-education"
          />
        </Field>
        <div className="flex items-center px-3 py-3 rounded-lg bg-stone-900/50 border border-stone-800">
          <Toggle
            checked={form.travel_available}
            onChange={(v) => set({ travel_available: v })}
            label="Available for travel"
            testid="about-travel"
          />
        </div>
      </div>
    </div>
  );
}
